var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:[
    'font-weight-medium text-uppercase text-body-1 button-widget',
    _vm.secondary ? 'grey--text text--darken-4' : 'white--text' ],attrs:{"color":!_vm.secondary ? '#5F86BC' : 'secondary',"min-width":_vm.minWidth,"height":"44px","depressed":"","tile":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }